export default {
    methods: {
        async get_robot_code_lab_project () {
            const { serialNumber, clientId, to } = this.b$.quick.store
            const data = {
              cmd: "get_robot_code_lab_project",
              data: {
                to: to || clientId,
                from: serialNumber,
                clientId: serialNumber,
                requestId: "wsGetRobotCodeLabProject-123",
                query: { limit: 10, page: 1 }
              }
            }
            this.b$.send('quick', data, response => {
                console.log(response, 'get_robot_code_lab_project')
            },
            {
                eventName: 'ws.cmd.update_robot_code_lab_project',
                callBack: response => {
                    console.log(response, 'update_robot_code_lab_project')
                }
            })
        },
        async del_robot_code_lab_project () {
            const { serialNumber, clientId, to } = this.b$.quick.store
            const data = {
              cmd: "del_robot_code_lab_project",
              data: {
                to: to || clientId,
                from: serialNumber,
                clientId: serialNumber,
                projectId: 1
              }
            }
            this.b$.send('quick', data, response => {
                console.log(response, 'del_robot_code_lab_project')
            },
            {
                eventName: 'ws.cmd.update_del_robot_code_lab_project',
                callBack: response => {
                    console.log(response, 'update_del_robot_code_lab_project')
                }
            })
        },
        async export_robot_code_lab_project () {
            const { serialNumber, clientId, to } = this.b$.quick.store
            const data = {
                cmd: "export_robot_code_lab_project",
                data: {
                    clientId: serialNumber,
                    to: to || clientId,
                    from: serialNumber,
                }
            }
            this.b$.send('quick', data, response => {
                console.log(response, 'export_robot_code_lab_project')
            },
            {
                eventName: 'ws.cmd.transfer_robot_code_lab_project',
                callBack: response => {
                    console.log(response, 'transfer_robot_code_lab_project')
                }
            })
        },
    }
}
